<template>
  <v-container fluid>
    <div class="error" v-if="error">
      <p>{{ error }}</p>
    </div>
    <div class="settings-section">
      <p
        class="information center"
        v-html="$t('app.settings.general.translation-info')"
      ></p>
      <ListItem
        class="list-item"
        :noTopBorder="index === 0"
        :last="index === languages.length - 1"
        v-for="(lang, index) in languages"
        :key="lang"
        :highlighted="selectedLanguage === lang"
        @click.native="saveDeeplLanguage(lang)"
      >
        <span>{{ $t(`general.languages.${lang}`) }}</span>
        <span v-if="selectedLanguage === lang" class="icon check-pink">
          <img :src="require('@/assets/icons/check-pink.svg')" class="icon" />
        </span>
      </ListItem>
    </div>
    <div v-html="disclaimer">
    </div>
  </v-container>
</template>

<script>
import CountryFlag from "vue-country-flag";
import {getSupportedLocales, redirect} from "@/helpers";
import { neoparentUsers, neoparentPatients } from "@/api";
import disclaimers from './disclaimers.json'
export default {
  name: "neoparent-translation-language",
  components: {
    CountryFlag
  },
  data() {
    return {
      selectedLanguage: null,
      languages: [],
      error: null
    };
  },
  mounted() {
    this.selectedLanguage = this.$store.getters.user.translationLanguage;
    this.languages = getSupportedLocales("all", this.$store.getters.user.language)
  },
  computed: {
    disclaimer() {
      var lang = (this.$store.getters.user.translationLanguage || '').substring(0, 2);
      let res = disclaimers[lang]
      if (res) {
        return res
      } else {
        return disclaimers['en'];
      }
    }
  },
  methods: {
    saveDeeplLanguage(lang) {
      const that = this
      neoparentUsers
        .editDeeplLanguage(lang)
        .then(result => {
          that.$store.commit('updateUser', result.data.parent)
          if (that.$store.getters.user.role !== 'n' && that.$store.getters.user.role !== 'a'){
            redirect("/settings");
          } else {
            redirect("/dashboard")
          }
        })
        .catch(err => {
          this.consoleLog(err);
        });
    }
  }
};
</script>

<style scoped lang="scss">
.information {
  margin: 2rem auto;
}

.list-item {
  display: flex;
  align-items: center;

  span {
    margin-right: 1rem;

    &.icon {
      margin-left: auto;
    }
  }
}
</style>
